import React from 'react';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { propTypes } from 'react-bootstrap/esm/Image';
import Cookies from 'universal-cookie';
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from '../../../app/utilities/helpers';
const proxy = GetProxy();
const cookies = new Cookies();

export const budgetedVsActualCostTrend = createAsyncThunk(
    "post/budgetedVsActualCostTrend",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCostTrendGraph`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json();

            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const costTrendApplication = createAsyncThunk(
    "post/costTrendApplication",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCostTrendByApplication`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json();

            return response.ok ?  data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const costTrendAccountId = createAsyncThunk(
    "post/costTrendAccountId",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCostTrendByAccountId`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json(); 
            
            return response.ok ?  data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const costTrendResources = createAsyncThunk(
    "post/costTrendResources",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getTopFiveServiceByAccountId`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json(); 
            return response.ok ?  data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const costTrendRegion = createAsyncThunk(
    "post/costTrendRegion",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getTopFiveRegionByAccountId`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json(); 

            return response.ok ?  data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const getFinancialYearsListAPI = createAsyncThunk(
    "post/getFinancialYearsListAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getFinancialYearsList`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json(); 

            return response.ok ?  data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const cloudCost = createAsyncThunk(
    "post/cloudCost",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
        const { pageNumber, itemsPerPage, payload } = props;

        const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCloudCostListSearchAndPagination/${pageNumber}/${itemsPerPage}`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "CMTS-API-TOKEN": apiToken,
                USERNAME: username,

            },
            body: JSON.stringify(payload)
        })
        handleResponseCode(response);
        const data = await response.json(); 
        return response.ok ?  data : Promise.reject(data);
    } catch(error) {
        console.log("Error", error);
        throw(error)
    }
    });

export const cloudCostDrill = createAsyncThunk(
    "posts/getDrill",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
        const { pageNumber, itemsPerPage, payload } = props;
        const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCloudCostByAccountIdSearchPaginationDrillDown1/${pageNumber}/${itemsPerPage}`, {
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "CMTS-API-TOKEN": apiToken,
                USERNAME: username,
            },
            body: JSON.stringify(payload)
        })
        handleResponseCode(response);
        const data = await response.json(); 
        return response.ok ? data : Promise.reject(data);
    } catch(error){
        console.log('Error', error);
        throw(error)
    }
    });


export const cloudCostDrillDown = createAsyncThunk(
    "posts/getDrilldown",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
        const { accountId, pageNumber, itemsPerPage,payload, appCodes } = props;
        const response = await fetch(`${proxy}/api/v1/awsCloudCost/getRegionCostCountSortingAndPaginationListDrillDownTwo/${appCodes}/${accountId}/${pageNumber}/${itemsPerPage}`, {
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "CMTS-API-TOKEN": apiToken,
                USERNAME: username,
            },
            body:JSON.stringify(payload)    
        })
        handleResponseCode(response);
        const data = await response.json(); 
        return response.ok ? data : Promise.reject(data);
    } catch(error){
        console.log('Error', error);
        throw(error)
    }
    });
    export const cloudCostPagenation = createAsyncThunk(
        "posts/getTablePage",
        async (props) => {
            const apiToken = cookies.get("apitoken");
            const username = cookies.get("username");
            try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCloudCostListSearchAndPaginationCount`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body:JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json(); 
            return response.ok ? data : Promise.reject(data);
        } catch(error){
            console.log('Error', error);
            throw(error)
        }
        });
        export const cloudCostDrillPagenation = createAsyncThunk(
            "posts/getDrillCountPage",
            async (props) => {
                const apiToken = cookies.get("apitoken");
                const username = cookies.get("username");
                try {
                const { payload } = props;
                const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCloudCostByAccountIdSearchPaginationCountDrillDown1`, {
                    method: 'POST',
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body:JSON.stringify(payload)
                })
                handleResponseCode(response);
                const data = await response.json(); 
                return response.ok ? data : Promise.reject(data);
                } catch(error){
                console.log('Error', error);
                throw(error)
            }
            });

            export const cloudCostRegionCount = createAsyncThunk(
                "posts/getDrillRegionCountPage",
                async (props) => {
                    const apiToken = cookies.get("apitoken");
                    const username = cookies.get("username");
                    try{
                    const { accountId , payload } = props;
                    const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCloudCostByAccountIdSearchPaginationCountDrillDown2/${accountId}`, {
                        method: 'POST',
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "CMTS-API-TOKEN": apiToken,
                            USERNAME: username,
                        },
                        body:JSON.stringify(payload)
                    })
                    handleResponseCode(response);
                    const data = await response.json(); 
                    return response.ok ? data : Promise.reject(data);
                } catch(error){
                    console.log('Error', error);
                    throw(error)
                }
                });
export const getFilteredCSP = createAsyncThunk(
    "posts/getFilteredCSP",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { CSPpayload } = props;
            const payload = CSPpayload;
            const response = await fetch(`${proxy}/api/v1/CSPForAws/appCodes`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log('Error', error);
            throw (error)
        }
    });
    export const CostVarianceAPI = createAsyncThunk(
        "post/CostVarianceAPI",
        async (props) => {
            const apiToken = cookies.get("apitoken");
            const username = cookies.get("username");
            try {
                const { pageNumber, itemsPerPage, payload } = props;
                const response = await fetch(`${proxy}/api/v1/awsCloudCost/getMonthCostVarianceGraphData`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "CMTS-API-TOKEN": apiToken,
                            USERNAME: username,
                        },
                        body: JSON.stringify(payload),
                    }
                );
                handleResponseCode(response);
                const data = await response.json();

                return response.ok ? data : Promise.reject(data);
            } catch (error) {
                throw error;
            }
        }
    )

    export const getForcastData = createAsyncThunk(
        "post/getForcastData",
        async () => {
          const Apitoken = cookies.get("apitoken");
          const User = cookies.get("username");
          try {
            const response = await fetch(
              `${proxy}/api/v1/cloudCostLandingPage/getMonthUsageForeCastData`,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "CMTS-API-TOKEN": Apitoken,
                  USERNAME: User,
                },
              }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
          } catch (error) {
            console.error("Error:", error);
            throw error;
          }
        }
    )

    export const getResourceSpend = createAsyncThunk(
        "post/getResourceSpend",
        async () => {
          const Apitoken = cookies.get("apitoken");
          const User = cookies.get("username");
          try {
            const response = await fetch(
              `${proxy}/api/v1/cloudCostLandingPage/getTotalSpendBreakdownByServiceCategories`,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "CMTS-API-TOKEN": Apitoken,
                  USERNAME: User,
                },
              }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
          } catch (error) {
            console.error("Error:", error);
            throw error;
          }
        }
    )

    export const getTop5AccountNameSpent = createAsyncThunk(
        "post/getTop5AccountNameSpent",
        async () => {
          const Apitoken = cookies.get("apitoken");
          const User = cookies.get("username");
          try {
            const response = await fetch(
              `${proxy}/api/v1/cloudCostLandingPage/getTopFiveHighestSpendingAwsAccounts`,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "CMTS-API-TOKEN": Apitoken,
                  USERNAME: User,
                },
              }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
          } catch (error) {
            console.error("Error:", error);
            throw error;
          }
        }
    )

    export const CurrentMontCostAPI = createAsyncThunk(
        "post/CurrentMontCostAPI",
        async (props) => {
            const apiToken = cookies.get("apitoken");
            const username = cookies.get("username");
            try {
                const { pageNumber, itemsPerPage, payload } = props;
                const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCurrentMontCostAndLastMonthCost`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "CMTS-API-TOKEN": apiToken,
                            USERNAME: username,
                        },
                        body: JSON.stringify(payload),
                    }
                );
                handleResponseCode(response);
                const data = await response.json();

                return response.ok ? data : Promise.reject(data);
            } catch (error) {
                throw error;
            }
        }
    )

    export const DetailsTablelist = createAsyncThunk(
        "post/DetailsTablelist",
        async (props) => {
            const apiToken = cookies.get("apitoken");
            const username = cookies.get("username");
            try {
            const { pageNumber, itemsPerPage, payload } = props;

            const response = await fetch(`${proxy}/api/v1/awsCloudCost/getCostOverViewDetailsTableList/${pageNumber}/${itemsPerPage}`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,

                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ?  data : Promise.reject(data);
        } catch(error) {
            console.log("Error", error);
            throw(error)
        }
        });


        export const DetailsTableCount= createAsyncThunk(
            "post/RiskassMaintableCountApi",
            async (props) => {
              const { payload } = props;
              const apiToken = cookies.get("apitoken");
              const username = cookies.get("username");
              try {
                const response = await fetch(
                  `${proxy}/api/v1/awsCloudCost/getCloudCostDetailsListCount`,
                  {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      "CMTS-API-TOKEN": apiToken,
                      USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                  }
                );
                handleResponseCode(response);
                const data = await response.json();

                return response.ok ? data : Promise.reject(data);
              } catch (error) {
                console.error("Error:", error);
                throw error;
              }
            }
          );

          //filter

          export const FilterForDetailsTable = createAsyncThunk(
            "get/FilterForDetailsTable",
            async (props) => {
              const Apitoken = cookies.get("apitoken");
              const User = cookies.get("username");
              try {

                const response = await fetch(
                  `${proxy}/api/v1/awsCloudCost/getAppCodeAndOpexId`,
                  {
                    method: "GET",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      "CMTS-API-TOKEN": Apitoken,
                      USERNAME: User,
                    }
                  }
                );
                handleResponseCode(response);
                const data = await response.json();
                return response.ok ? data : Promise.reject(data);
              } catch (error) {
                console.error("Error:", error);
                throw error;
              }
            }
          );



    export const getYearTillDateGraphAPI = createAsyncThunk(
        "post/getYearTillDateGraphAPI",
        async (props) => {
            const apiToken = cookies.get("apitoken");
            const username = cookies.get("username");
            try {
                const { pageNumber, itemsPerPage, payload } = props;
                const response = await fetch(`${proxy}/api/v1/awsCloudCost/getYearTillDateGraphData`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "CMTS-API-TOKEN": apiToken,
                            USERNAME: username,
                        },
                        body: JSON.stringify(payload),
                    }
                );
                handleResponseCode(response);
                const data = await response.json();

                return response.ok ? data : Promise.reject(data);
            } catch (error) {
                throw error;
            }
        }
    )

const initialState = {
    cloudTableData: [],
    cloudData: [],
    cloudDataDrill: [],
    costTrendRegionData: [],
    costTrendResourcesData: [],
    costTrendAccountIdData: [],
    costTrendApplicationData: [],
    budgetedVsActualCostTrendData: [],
    cloudCostTablePage:[],
    cloudCostDrillPageCount:[],
    cloudCostDrillRegionCount:[],
    CSPFilterData: [],
    getFinancialYearsData:[],
    getFinancialYearsLoading:false,
    loading: false,
    DrillLoading: false,
    regionLoading:false,
    tableCountloading:false,
    drillCountLoading:false,
    regionCountLoading:false,
    accLoading:false,
    appLoading:false,
    bvaLoading:false,
    resLoading:false,
    regLoading:false,
    filterLoading: false,
    forcastDataLoading :  false,
    forcastData : [],
    ResourceSpendLoading :  false,
    ResourceSpendData : [],
    Top5SpendLoading :  false,
    Top5SpendData : [],
    CostVarianceLoading:false,
    CostVarianceData: [],
    CurrentMontCostData:[],
    CurrentMontCostLoading:false,
    DetailsTableData:[],
    DetailsTableloading:false,
    DetailsTableCountloading:false,
    DetailsTableCountData:[],
    FilterDataLoading:false,
    FilterData:[],
    getYearTillDateGraphData:[],
    getYearTillDateGraphLoading:false,
    error : "",
    apiError : false,
};

export const CostSlice = createSlice({
    name: 'cloudCostSlice',
    initialState,


    reducers: {
       resetCostSliceData: () => {
        return initialState;
       },
       setcloudTableData: (state, action) => {
        state.cloudTableData = action.payload;
       },
       setApiError: (state, action) => {
        state.apiError = false;
       },
    },
    extraReducers: (builder) => {
        builder
            .addCase(budgetedVsActualCostTrend.pending, (state, action) => {
                state.bvaLoading = true;
                state.apiError = false;
            })
            .addCase(budgetedVsActualCostTrend.fulfilled, (state, action) => {
                state.budgetedVsActualCostTrendData = action.payload;
                state.bvaLoading = false;
                state.apiError = false;
            })
            .addCase(budgetedVsActualCostTrend.rejected, (state, action) => {
                state.bvaLoading = false;
                state.budgetedVsActualCostTrendData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(costTrendApplication.pending, (state, action) => {
                state.appLoading = true;
                state.apiError = false;
            })
            .addCase(costTrendApplication.fulfilled, (state, action) => {
                state.costTrendApplicationData = action.payload;
                state.appLoading = false;
                state.apiError = false;
            })
            .addCase(costTrendApplication.rejected, (state, action) => {
                state.appLoading = false;
                state.costTrendApplicationData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(costTrendAccountId.pending, (state, action) => {
                state.accLoading = true;
                state.apiError = false;
            })
            .addCase(costTrendAccountId.fulfilled, (state, action) => {
                state.costTrendAccountIdData = action.payload;
                state.accLoading = false;
                state.apiError = false;
            })
            .addCase(costTrendAccountId.rejected, (state, action) => {
                state.accLoading = false;
                state.costTrendAccountIdData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(costTrendResources.pending, (state, action) => {
                state.resLoading = true;
                state.apiError = false;
            })
            .addCase(costTrendResources.fulfilled, (state, action) => {
                state.costTrendResourcesData = action.payload;
                state.resLoading = false;
                state.apiError = false;
            })
            .addCase(costTrendResources.rejected, (state, action) => {
                state.resLoading = false;
                state.costTrendResourcesData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(costTrendRegion.pending, (state, action) => {
                state.regLoading = true;
                state.apiError = false;
            })
            .addCase(costTrendRegion.fulfilled, (state, action) => {
                state.costTrendRegionData = action.payload;
                state.regLoading = false;
                state.apiError = false;
            })
            .addCase(costTrendRegion.rejected, (state, action) => {
                state.regLoading = false;
                state.costTrendRegionData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(cloudCost.pending, (state, action) => {
                state.loading = true;
                state.apiError = false;
            })
            .addCase(cloudCost.fulfilled, (state, action) => {
                state.cloudTableData = action.payload;
                state.loading = false;
                state.apiError = false;
            })
            .addCase(cloudCost.rejected, (state, action) => {
                state.loading = false;
                state.cloudTableData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })


            .addCase(cloudCostDrill.pending, (state, action) => {
                state.DrillLoading = true;
                state.apiError = false;
            })
            .addCase(cloudCostDrill.fulfilled, (state, action) => {
                state.cloudData = action.payload;
                state.DrillLoading = false;
                state.apiError = false;
            })
            .addCase(cloudCostDrill.rejected, (state, action) => {
                state.DrillLoading = false;
                state.cloudData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })


            .addCase(cloudCostDrillDown.pending, (state, action) => {
                state.regionLoading = true;          
                state.apiError = false;     
            })
            .addCase(cloudCostDrillDown.fulfilled, (state, action) => {
                state.cloudDataDrill = action.payload;
                state.regionLoading = false;
                state.apiError = false;
            })
            .addCase(cloudCostDrillDown.rejected, (state, action) => {
                state.regionLoading = false;
                state.cloudDataDrill = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })


            .addCase(cloudCostPagenation.pending, (state, action) => {
                state.tableCountloading = true;
                state.apiError = false;
            })
            .addCase(cloudCostPagenation.fulfilled, (state, action) => {
                state.cloudCostTablePage = action.payload;
                state.tableCountloading = false;
                state.apiError = false;
            })
            .addCase(cloudCostPagenation.rejected, (state, action) => {
                state.tableCountloading = false;
                state.cloudCostTablePage = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })


            .addCase(cloudCostDrillPagenation.pending, (state, action) =>{
                state.drillCountLoading = true;
                state.apiError = false;
            })
            .addCase(cloudCostDrillPagenation.fulfilled, (state, action) =>{
                state.cloudCostDrillPageCount = action.payload;
                state.drillCountLoading = false;
                state.apiError = false;
            })
            .addCase(cloudCostDrillPagenation.rejected, (state, action) =>{
                state.drillCountLoading = false;
                state.cloudCostDrillPageCount = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })
  

            .addCase(cloudCostRegionCount.pending, (state, action) => {
                state.regionCountLoading = true ;
                state.apiError = false;
            })
            .addCase(cloudCostRegionCount.fulfilled, (state, action) => {
                state.cloudCostDrillRegionCount = action.payload;
                state.regionCountLoading = false;
                state.apiError = false;

            })
            .addCase(cloudCostRegionCount.rejected, (state, action) => {
                state.regionCountLoading = false;
                state.cloudCostDrillRegionCount = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //getFinancialYearsListAPI
            .addCase(getFinancialYearsListAPI.pending, (state, action) => {
                state.getFinancialYearsLoading = true ;
                state.apiError = false;
            })
            .addCase(getFinancialYearsListAPI.fulfilled, (state, action) => {
                state.getFinancialYearsData = action.payload;
                state.getFinancialYearsLoading = false;
                state.apiError = false;

            })
            .addCase(getFinancialYearsListAPI.rejected, (state, action) => {
                state.getFinancialYearsLoading = false;
                state.getFinancialYearsData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(getFilteredCSP.pending, (state, action) => {
                state.filterLoading = true ;
                state.apiError = false;
            })
            .addCase(getFilteredCSP.fulfilled, (state, action) => {
                state.CSPFilterData = action.payload;
                state.filterLoading = false;
                state.apiError = false;

            })
            .addCase(getFilteredCSP.rejected, (state, action) => {
                state.filterLoading = false;
                state.forcastData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(getForcastData.pending, (state, action) => {
                state.forcastDataLoading = true ;
                state.apiError = false;
            })
            .addCase(getForcastData.fulfilled, (state, action) => {
                state.forcastData = action.payload;
                state.forcastDataLoading = false;
                state.apiError = false;

            })
            .addCase(getForcastData.rejected, (state, action) => {
                state.forcastDataLoading = false;
                state.forcastData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            .addCase(getResourceSpend.pending, (state, action) => {
                state.ResourceSpendLoading = true ;
                state.apiError = false;
            })
            .addCase(getResourceSpend.fulfilled, (state, action) => {
                state.ResourceSpendData = action.payload;
                state.ResourceSpendLoading = false;
                state.apiError = false;

            })
            .addCase(getResourceSpend.rejected, (state, action) => {
                state.ResourceSpendLoading = false;
                state.ResourceSpendData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })
            .addCase(getTop5AccountNameSpent.pending, (state, action) => {
                state.Top5SpendLoading = true ;
                state.apiError = false;
            })
            .addCase(getTop5AccountNameSpent.fulfilled, (state, action) => {
                state.Top5SpendData = action.payload;
                state.Top5SpendLoading = false;
                state.apiError = false;

            })
            .addCase(getTop5AccountNameSpent.rejected, (state, action) => {
                state.Top5SpendLoading = false;
                state.Top5SpendData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            ////CostVarianceAPI
            .addCase(CostVarianceAPI.pending, (state, action) => {
                state.CostVarianceLoading = true ;
                state.apiError = false;
            })
            .addCase(CostVarianceAPI.fulfilled, (state, action) => {
                state.CostVarianceData = action.payload;
                state.CostVarianceLoading = false;
                state.apiError = false;

            })
            .addCase(CostVarianceAPI.rejected, (state, action) => {
                state.CostVarianceLoading = false;
                state.CostVarianceData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            ////CostVarianceAPI
            .addCase(CurrentMontCostAPI.pending, (state, action) => {
                state.CurrentMontCostLoading = true ;
                state.apiError = false;
            })
            .addCase(CurrentMontCostAPI.fulfilled, (state, action) => {
                state.CurrentMontCostData = action.payload;
                state.CurrentMontCostLoading = false;
                state.apiError = false;

            })
            .addCase(CurrentMontCostAPI.rejected, (state, action) => {
                state.CurrentMontCostLoading = false;
                state.CurrentMontCostData = [];
                state.error = "Something went wrong";
                state.apiError = true;

            })

            .addCase(DetailsTablelist.pending, (state, action) => {
                state.DetailsTableloading = true;
                state.apiError = false;
            })
            .addCase(DetailsTablelist.fulfilled, (state, action) => {
                state.DetailsTableData = action.payload;
                state.DetailsTableloading = false;
                state.apiError = false;
            })
            .addCase(DetailsTablelist.rejected, (state, action) => {
                state.DetailsTableloading = false;
                state.DetailsTableData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

//count
            .addCase(DetailsTableCount.pending, (state, action) => {
                state.DetailsTableCountloading = true;
                state.apiError = false;
            })
            .addCase(DetailsTableCount.fulfilled, (state, action) => {
                state.DetailsTableCountData = action.payload;
                state.DetailsTableCountloading = false;
                state.apiError = false;
            })
            .addCase(DetailsTableCount.rejected, (state, action) => {
                state.DetailsTableCountloading = false;
                state.DetailsTableCountData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            // filter

            .addCase(FilterForDetailsTable.pending, (state, action) => {
                state.FilterDataLoading = true;
              })
              .addCase(FilterForDetailsTable.fulfilled, (state, action) => {
                state.FilterDataLoading = false;
                state.FilterData = action.payload;
              })
              .addCase(FilterForDetailsTable.rejected, (state, action) => {
                state.FilterDataLoading = false;
                state.FilterData = []
              })

        ////getYearTillDateGraphAPI
            .addCase(getYearTillDateGraphAPI.pending, (state, action) => {
                state.getYearTillDateGraphLoading = true ;
                state.apiError = false;
            })
            .addCase(getYearTillDateGraphAPI.fulfilled, (state, action) => {
                state.getYearTillDateGraphData = action.payload;
                state.getYearTillDateGraphLoading = false;
                state.apiError = false;

            })
            .addCase(getYearTillDateGraphAPI.rejected, (state, action) => {
                state.getYearTillDateGraphLoading = false;
                state.getYearTillDateGraphData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            });
    },

});

export const {resetCostSliceData,setcloudTableData, setApiError} = CostSlice.actions;
export default CostSlice.reducer;